import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {drugCategoryApi, drugInventoryApi, drugVendorApi} from '../../Context/apiData';

import {getSelectedBranch, normalizeBranch, withBranchParams, withBranchPayload} from '../../utils/branchUtils';

export const getDrugInventory = createAsyncThunk('drugInventory/getDrugInventory', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.get(drugInventoryApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const createDrugInventory = createAsyncThunk('drugInventory/createDrugInventory', async (drugInventoryData, {rejectWithValue}) => {
  try {
    const response = await axios.post(drugInventoryApi, withBranchPayload(drugInventoryData), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const updateDrugInventory = createAsyncThunk('drugInventory/updateDrugInventory', async payload => {
  try {
    const response = await axios.put(`${drugInventoryApi}${payload.id}/`, withBranchPayload(payload), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const deleteDrugInventory = createAsyncThunk('drugInventory/deleteDrugInventory', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.delete(`${drugInventoryApi}${payload}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return {id: payload}; // Return deleted item ID for state update
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getCategories = createAsyncThunk('drugInventory/getCategories', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.get(drugCategoryApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: payload
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const createCategory = createAsyncThunk('drugInventory/createCategory', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.post(drugCategoryApi, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const updateCategory = createAsyncThunk('drugInventory/updateCategory', async payload => {
  try {
    const response = await axios.put(`${drugCategoryApi}${payload.id}/`, payload, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data.data;
  } catch (error) {
    if (error.response.data.status.code === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const deleteCategory = createAsyncThunk('drugInventory/deleteCategory', async (id, {rejectWithValue}) => {
  try {
    await axios.delete(`${drugCategoryApi}${id}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return {id};
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getVendors = createAsyncThunk('drugInventory/getVendors', async (_, {rejectWithValue}) => {
  try {
    const response = await axios.get(drugVendorApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const createVendor = createAsyncThunk('drugInventory/createVendor', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.post(drugVendorApi, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const updateVendor = createAsyncThunk('drugInventory/updateVendor', async payload => {
  try {
    const response = await axios.put(`${drugVendorApi}${payload.id}/`, payload, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data.data;
  } catch (error) {
    if (error.response.data.status.code === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const deleteVendor = createAsyncThunk('drugInventory/deleteVendor', async (id, {rejectWithValue}) => {
  try {
    await axios.delete(`${drugVendorApi}${id}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return {id};
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});
